(function () {
'use strict';

angular
    .module('surveyCampaignRoutes', [
        'surveyCampaignControllers',
        'surveyCampaignOwnerRoutes',
    ])
    .config(routeur);

    routeur.$inject = ['$stateProvider'];

    function routeur($stateProvider) {
        $stateProvider

             .state('survey.campaign', {
                 url: '/Campaign',
                 views: {
                     'sidebar@survey': {
                         templateUrl: require('./sidebarCampaignList.tpl.html'),
                         controller: 'SidebarCampaignController',
                         resolve: {
                             campaign: function () { return {}; }
                         }
                     },
                     'mainContent@survey': {
                         templateUrl: require('./campaignList.tpl.html'),
                         controller: 'CampaignListController',
                         resolve: {
                             campaigns: ['surveyCampaignService', function (service) {
                                 return service.getAllActiveCampaigns();
                             }]
                         }
                     }
                 }
             })

            .state('survey.campaign.new', {
                url: '/New',
                views: {
                    'sidebar@survey': {
                        templateUrl: require('./sidebarNewCampaign.tpl.html'),
                        controller: 'SidebarCampaignController',
                        resolve: {
                            campaign: function () { return {}; }
                        }
                    },
                    'mainContent@survey': {
                        templateUrl: require('./newCampaign.tpl.html'),
                        controller: 'NewCampaignController'
                    }
                }
            })

            .state('survey.campaign.slug', {
                url: '/{Year}/{Month}/{Day}/{Title}',
                resolve: {
                    campaign: ['$stateParams', 'surveyCampaignService', function ($stateParams, service) {
                        return service.getCampaign($stateParams);
                    }],
                    parts: ['$stateParams', 'surveyCampaignService', function ($stateParams, service) {
                        return service.getCampaignParts($stateParams);
                    }]
                },
                views: {
                    'sidebar@survey': {
                        templateUrl: require('./sidebarCampaign.tpl.html'),
                        controller: 'SidebarCampaignController'
                    },
                    'mainContent@survey': {
                        templateUrl: require('./campaign.tpl.html'),
                        controller: 'CampaignController',
                        resolve: {
                            respondents: ['$stateParams', 'surveyCampaignService', function ($stateParams, service) {
                                return service.getCampaignRespondents($stateParams);
                            }],
                        },
                    }
                }
            })

            .state('survey.campaign.slug.settings', {
                url: '/Settings',
                views: {
                    'mainContent@survey': {
                        templateUrl: require('./campaignSettings.tpl.html'),
                        controller: 'CampaignSettingsController',
                    }
                }
            })

            .state('survey.campaign.slug.part', {
                url: '/Section',
                views: {
                    'mainContent@survey': {
                        templateUrl: require('./campaignParts.tpl.html'),
                        controller: 'CampaignPartsController',
                    }
                }
            })

            .state('survey.campaign.slug.part.builder', {
                url: '/{CampaignPartID:int}',
                resolve: {
                    part: ['$stateParams', 'parts', function ($stateParams, parts) {
                        return _.find(parts, { CampaignPartID: $stateParams.CampaignPartID });
                    }],
                    questionTypes: ['surveyCampaignService', function (service) {
                        return service.getQuestionTypes();
                    }],
                    visualComponentTypes: [function () {
                        return [{
                            VisualComponentTypeCode: 'BreakPage',
                            VisualComponentTypeID: 1,
                            IconCssClasses: 'fa fa-arrows-h'
                        }];
                    }]
                },
                views: {
                    'sidebar@survey': {
                        templateUrl: require('./sidebarCampaignPartBuilder.tpl.html'),
                        controller: 'SidebarCampaignPartBuilderController'
                    },
                    'mainContent@survey': {
                        templateUrl: require('./campaignPartBuilder.tpl.html'),
                        controller: 'CampaignPartBuilderController',
                    }
                }
            })

            .state('survey.campaign.slug.part.builder.reorderComponents', {
                data: {
                    isOrderingComponents: true
                },
                views: {
                    'mainContent@survey': {
                        templateUrl: require('./campaignPartBuilder.tpl.html'),
                        controller: 'CampaignPartBuilderController',
                    }
                },
            })

            .state('survey.campaign.slug.part.builder.newQuestion', {
                url: '/NewQuestion/{QuestionTypeID:int}',
                resolve: {
                    questionType: ['$stateParams', 'questionTypes', function ($stateParams, questionTypes) {
                        return _.find(questionTypes, { QuestionTypeID: $stateParams.QuestionTypeID });
                    }]
                },
                views: {
                    //'sidebar@survey': {
                    //    templateUrl: require('./sidebarCampaignPartBuilder.tpl.html'),
                    //    controller: 'SidebarCampaignController'
                    //},
                    'mainContent@survey': {
                        templateUrl: require('./campaignPartAddQuestion.tpl.html'),
                        controller: 'CampaignPartAddQuestionController',
                    }
                }
            });
    }
})();